function ValidateMLValue(option, value) {
  const maxValue = option === 'angle' ? 360 : null;
  const minValue = option === 'angle' ? 0 : null;
  let validateValue = true;
  let warning = '';
  if (typeof value === 'number') {
    if (maxValue !== null && value > maxValue) {
      validateValue = false;
      warning = warning + `Maximum is ${Math.round(maxValue * 10) / 10}`;
    }
    if (minValue !== null && value < minValue) {
      validateValue = false;
      warning = warning + `Minimum is ${Math.round(minValue * 10) / 10}`;
    }
  }
  if (['', 'select an option', null, undefined].includes(value)) {
    validateValue = false;
    warning = warning + 'input required';
  }
  return { validateValue, warning };
}

export default ValidateMLValue;
